import { render, staticRenderFns } from "./ViewTicketScreen.vue?vue&type=template&id=be4fc2ba&scoped=true&"
import script from "./ViewTicketScreen.vue?vue&type=script&lang=js&"
export * from "./ViewTicketScreen.vue?vue&type=script&lang=js&"
import style0 from "./ViewTicketScreen.vue?vue&type=style&index=0&id=be4fc2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4fc2ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VFooter,VRow})
